export default "__VITE_ASSET__5825337d__"